export default {
    data() {
        return {
            windowRef: null,
        }
    },

    methods: {
        createNewBrowserTab() {
            this.windowRef = window.open();
        },
        openUrlInNewTab(url) {
            this.windowRef.location = url;
        }
    },

    beforeDestroy() {
        this.windowRef = null;
    },
}
